<template>
    <div class="no-data-container" v-if="!collection || (Utils.notNull(collection) && collection && collection.length == 0)">
        <img :src="require('@/web-framework/assets/images/nodata.png')" style="width:100%;max-width: 100%;max-height: 100%;">
        <p v-if="message && message.length > 0">{{message}}</p>
        <slot name='content'></slot>
    </div>
</template>
<script>
export default {
    props: {
        collection: {
            type: Array,
            default: null
        },
        message: {
            type: String,
            default: ""
        }
    },
    watch: {
        collection(val) {
        }
    },
    mounted() {

    }
};
</script>
<style lang="less" scoped>
.no-data-container {
    text-align: center;
    color: #919191;
    width: 100%;
    height: 100%;
    p {
        font-size: 16px;
        padding: 10px;
    }
    .iconfont {
        font-size: 100px;
        color: #3c8ce7;
    }
}
</style>